import classnames from 'classnames';
import StarIconPartial from 'components/icons/StarIconPartial';
import React, { ReactNode, memo } from 'react';

import StarIcon from '../icons/StarIcon';
import StarIconLine from '../icons/StarIconLine';

const CSS = require('./StarRating.module.scss');

const STAR_RATING_SCALE = 5;

interface StarRatingProps {
  rating: number;
  scale?: number;
  iconClassname?: string;
  className?: string;
  width?: number;
  height?: number;
  isCondensed?: boolean;
  usePartials?: boolean;
}

function StartListWithPartials({ rating, className, width, height }) {
  const list: ReactNode[] = [];
  Array(5)
    .fill(0)
    .reduce((current, _, index) => {
      const value = current >= 0.75 ? 1 : current;
      list.push(
        <StarIconPartial
          key={index}
          value={value}
          className={classnames(CSS.Icon, CSS.IconWithPartial, {
            [className]: className,
          })}
          width={width}
          height={height}
        />,
      );
      return current - (current >= 0.75 ? 1 : current);
    }, rating);
  return <>{list}</>;
}

function StarList({ rating, className, width, height }) {
  const list = [];
  for (let i = 1; i <= 5; i += 1) {
    if (i > rating) {
      list.push(
        <StarIconLine
          key={i}
          className={classnames(CSS.Icon, { [className]: className })}
          width={width}
          height={height}
        />,
      );
    } else {
      list.push(
        <StarIcon
          key={i}
          className={classnames(CSS.Icon, { [className]: className })}
          width={width}
          height={height}
        />,
      );
    }
  }
  return <>{list}</>;
}

function StarRating({
  rating,
  scale,
  className,
  iconClassname,
  width,
  height,
  isCondensed,
  usePartials,
}: StarRatingProps) {
  const starRating = !!scale
    ? Math.ceil((rating / scale) * STAR_RATING_SCALE)
    : rating;
  return (
    <div
      className={classnames(CSS.Rating, {
        [CSS.CondensedRating]: isCondensed,
        className: !!className,
      })}
    >
      {usePartials ? (
        <StartListWithPartials
          rating={starRating}
          className={iconClassname}
          width={width}
          height={height}
        />
      ) : starRating === STAR_RATING_SCALE ? (
        <>
          <StarIcon
            className={classnames(CSS.Icon, {
              [iconClassname]: !!iconClassname,
            })}
            width={width}
            height={height}
          />
          <StarIcon
            className={classnames(CSS.Icon, {
              [iconClassname]: !!iconClassname,
            })}
            width={width}
            height={height}
          />
          <StarIcon
            className={classnames(CSS.Icon, {
              [iconClassname]: !!iconClassname,
            })}
            width={width}
            height={height}
          />
          <StarIcon
            className={classnames(CSS.Icon, {
              [iconClassname]: !!iconClassname,
            })}
            width={width}
            height={height}
          />
          <StarIcon
            className={classnames(CSS.Icon, {
              [iconClassname]: !!iconClassname,
            })}
            width={width}
            height={height}
          />
        </>
      ) : (
        <StarList
          rating={starRating}
          className={iconClassname}
          width={width}
          height={height}
        />
      )}
    </div>
  );
}

export default memo(StarRating);
